import { Component, OnInit, Inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import {
  caseListTemplate,
  CaseListComponent,
  Filter,
  ResourceDefinition,
  BreadcrumbService,
  FlashMessageService,
  ResourceService,
  CaseConfig,
  Yield,
  InputType,
  AuthService,
  FilterService
} from '@case-app/angular-library'
import { customerDefinition } from '../../customer/customer.definition'

import { referentDefinition } from '../referent.definition'
import { referentYields } from '../referent.yields'

@Component({ template: caseListTemplate })
export class ReferentListComponent extends CaseListComponent implements OnInit {
  definition: ResourceDefinition = referentDefinition
  yields: Yield[] = referentYields

  filters: Filter[] = [
    {
      label: 'Rechercher un responsable',
      placeholder: 'Rechercher par nom ou par client...',
      inputType: InputType.MultiSearch,
      className: 'is-12',
      searchResources: [referentDefinition, customerDefinition],
      properties: {
        referentIds: 'referentIds',
        customerIds: 'customerIds'
      }
    }
  ]

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    resourceService: ResourceService,
    breadcrumbService: BreadcrumbService,
    flashMessageService: FlashMessageService,
    filterService: FilterService,
    authService: AuthService,
    @Inject('CASE_CONFIG_TOKEN') config: CaseConfig
  ) {
    super(
      router,
      activatedRoute,
      breadcrumbService,
      resourceService,
      flashMessageService,
      authService,
      filterService,
      config
    )
  }

  ngOnInit() {
    this.initListView()
  }
}
